import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
// import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
// import { useLocalStorage } from "../../utils/useLocalStorage";
// import Pagination from "../../CommonUI/Pagination/Pagination";
// import { Portal } from "@material-ui/core";
// import { Modal } from "react-bootstrap";
// import { Vortex } from 'react-loader-spinner';

function CurrencyTable() {
    const [show, setShow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    const [dataWatch, setDataWatch] = useState([]);

    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);
    const [loadingshow, setloadingshow] = useState(false);
    let getDataWatch, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;


    useEffect(() => {
        postData('/api/Login/currencytrading')
            .then((data) => {

                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }




    return (
        <>


            <section class="currency-india theme-color section-padding">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 text-center ">
                            <h2 class="tableC-title title blue-title mx-auto text-center mb-5">Currency Trading Pairs for India</h2>
                            <div class="tableC-responsive table-responsive mb-4">
                                <table dir="ltr" class="tableC tableC-bordered ">
                                    <thead >
                                        <tr class="tableC-fonts">
                                            <th className="text-left dataTblMarket">Currency</th>
                                            <th className="text-left dataTblMarket">Country</th>
                                            <th className="text-right dataTblMarket">INR Price</th>
                                            <th className="text-right dataTblMarket">Change</th>
                                            <th className="text-right dataTblMarket">Change(%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.map(
                                            ({ currency, country, inrPrice, srno, price_change, changeperc }) => (
                                                <>
                                                    <tr>
                                                        <td className="text-left">{currency}</td>
                                                        <td className="text-left">{country}</td>
                                                        <td><div className="text-right"> {inrPrice != null ? inrPrice.toFixed(2) : 0} </div></td>
                                                        <td><div className="text-right"> {price_change != null ? price_change.toFixed(2) : 0} </div></td>
                                                        <td><div className="text-right"> {changeperc != null ? changeperc.toFixed(2) : 0} </div></td>

                                                    </tr>
                                                </>
                                            )
                                        )}
                                    </tbody>
                                    {(data == null) ? <h6 className="errormsgMarket">No Data Found !!!</h6> : ''}
                                </table>
                            </div>
                            <a class="ctaf" href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">know more</a>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )


}

export default CurrencyTable